module.exports = __webpack_public_path__ + "img/holiday-breakfast-casserole.c4d4d7f6.jpg";